

export enum NotificationCategory {
    ALL = 'All',
    MY = 'My',
    USER_EVENTS = 'User Events',
    DATA_EVENTS = 'Data Events',
    KLIBRARY = 'Knowledge Library',
    ASSESSMENT = "Assessment Event",
    PERMISSION_REQUESTS = "Permission Requests"
}